<template>
	<div class="p-6 space-y-4">
		<h1 class="text-2xl font-semibold text-gray-900">
			{{ __("Contact details") }}
		</h1>

		<div class="grid grid-cols-2 gap-y-4 gap-x-6">
			<ui-select-group
				class="col-span-2"
				v-model="form.salutation"
				type="select"
				field="salutation"
				label="Salutation"
				:options="$cropOptions.salutationOptions"
				:form="form"
				:required="true"
			></ui-select-group>
			<ui-input-group
				class="col-span-2"
				v-model="form.title"
				field="name"
				label="Title"
				:form="form"
				:required="false"
			></ui-input-group>
			<ui-input-group
				class="col-span-2"
				v-model="form.first_name"
				field="name"
				label="First Name"
				:form="form"
				:required="true"
			></ui-input-group>
			<ui-input-group
				class="col-span-2"
				v-model="form.last_name"
				field="name"
				label="Last Name"
				:form="form"
				:required="true"
			></ui-input-group>
			<ui-input-group
				class="col-span-2"
				v-model="form.email"
				field="email"
				label="E-Mail"
				:form="form"
				:required="true"
			></ui-input-group>

			<ui-input-group
				class="col-span-2"
				v-model="form.email_cc"
				field="email_cc"
				label="E-Mail CC"
				:form="form"
				:required="false"
			></ui-input-group>

			<ui-input-group
				class="col-span-2"
				v-model="form.tel_mobile"
				field="tel_mobile"
				label="Telephone (Mobile)"
				type="text"
				autocomplete="tel"
				:form="form"
				:required="true"
			></ui-input-group>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		user: {
			type: Object,
			required: true,
		},
		form: {
			type: Object,
			required: true,
		},
	},
};
</script>
